angular.module('mercury.modules.qa.idealpos', [
  'mercury.modules.qa.idealpos.financialreport',
  'mercury.modules.qa.idealpos.itemsalesreport'
]);
